import React from "react";

export default () => {
  return (
    <svg
      width="203px"
      height="130px"
      viewBox="0 0 203 130"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Category A</title>
      <defs>
        <linearGradient
          x1="53.2032988%"
          y1="33.4769388%"
          x2="50%"
          y2="53.5953884%"
          id="ca-linearGradient-1"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <polygon
          id="ca-path-2"
          points="14 83 189.799997 83 189.799997 126 14 126"
        ></polygon>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="ca-linearGradient-3"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M64,0 L79,0 C80.1045695,-2.02906125e-16 81,0.8954305 81,2 L81,32 L81,32 L60,32 L60,4 C60,1.790861 61.790861,4.05812251e-16 64,0 Z"
          id="ca-path-4"
        ></path>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="ca-linearGradient-5"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M5,0 L50,0 C52.7614237,-5.07265313e-16 55,2.23857625 55,5 L55,20 C55,22.7614237 52.7614237,25 50,25 L5,25 C2.23857625,25 3.38176876e-16,22.7614237 0,20 L0,5 C-3.38176876e-16,2.23857625 2.23857625,5.07265313e-16 5,0 Z"
          id="ca-path-6"
        ></path>
        <path
          d="M115,0 L160,0 C162.761424,-5.07265313e-16 165,2.23857625 165,5 L165,20 C165,22.7614237 162.761424,25 160,25 L115,25 C112.238576,25 110,22.7614237 110,20 L110,5 C110,2.23857625 112.238576,5.07265313e-16 115,0 Z"
          id="ca-path-7"
        ></path>
        <path
          d="M86,0 L101,0 C103.209139,-4.05812251e-16 105,1.790861 105,4 L105,32 L105,32 L84,32 L84,2 C84,0.8954305 84.8954305,2.02906125e-16 86,0 Z"
          id="ca-path-8"
        ></path>
        <linearGradient
          x1="53.2032988%"
          y1="-7.31575535%"
          x2="50%"
          y2="62.4718052%"
          id="ca-linearGradient-9"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M58,0 L144,0 C145.104569,-2.02906125e-16 146,0.8954305 146,2 L146,39 C146,40.1045695 145.104569,41 144,41 L58,41 C56.8954305,41 56,40.1045695 56,39 L56,2 C56,0.8954305 56.8954305,2.02906125e-16 58,0 Z"
          id="ca-path-10"
        ></path>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="ca-linearGradient-11"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M103.5002,29.60273 C103.5002,32.80193 98.6994,32.80193 98.6994,29.60273 C98.6994,26.39963 103.5002,26.39963 103.5002,29.60273 Z M112.8012,29.60273 C112.8012,32.80193 108.0004,32.80193 108.0004,29.60273 C108.0004,26.39963 112.8012,26.39963 112.8012,29.60273 Z M95.70012,9 C96.3017,9 96.89936,9.39844 97.00092,10 L97.00092,10 L97.70014,12.6016 L115.60614,12.59769 C116.00458,12.59769 116.30536,12.79691 116.60614,13.09769 C116.80536,13.39851 116.90692,13.80085 116.80536,14.19929 L116.80536,14.19929 L114.20376,24.80129 C114.00456,25.40285 113.50452,25.80129 112.90296,25.80129 L112.90296,25.80129 L99.30096,25.80129 C98.69938,25.80129 98.10172,25.40285 98.00016,24.80129 L98.00016,24.80129 L95.30096,14.30129 L95.30096,14.19973 L94.6994,11.69973 L92.00092,11.6992 C91.30168,11.6992 90.70012,11.00004 90.70012,10.3008 C90.70012,9.60156 91.3017,9 92.00092,9 L92.00092,9 Z M94.1994,22.29713 C94.89864,22.29713 95.5002,22.89871 95.5002,23.59793 C95.5002,24.29717 94.89862,24.89873 94.1994,24.89873 L94.1994,24.89873 L89.5002,24.89873 C88.80096,24.89873 88.1994,24.30105 88.1994,23.59793 C88.1994,22.89869 88.80098,22.29713 89.5002,22.29713 L89.5002,22.29713 Z M93.0004,18.09793 C93.69964,18.09793 94.3012,18.69951 94.3012,19.39873 C94.3012,20.10187 93.69962,20.60187 93.0004,20.69953 L93.0004,20.69953 L88.3012,20.69953 C87.60196,20.69953 87.0004,20.09795 87.0004,19.39873 C87.0004,18.69949 87.60198,18.09793 88.3012,18.09793 L88.3012,18.09793 Z M92,13.79713 C92.69924,13.79713 93.3008,14.39871 93.3008,15.09793 C93.3008,15.79717 92.69922,16.39873 92,16.39873 L92,16.39873 L87.1992,16.39873 C86.60156,16.39873 86,15.80105 86,15.09793 C86,14.39869 86.60158,13.79713 87.3008,13.79713 L87.3008,13.79713 Z"
          id="ca-path-12"
        ></path>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="146.694484%"
          id="ca-linearGradient-13"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <rect
          id="ca-path-14"
          x="43.4999983"
          y="52.1999996"
          width="116"
          height="7"
          rx="1"
        ></rect>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="ca-linearGradient-15"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M5,58 L197,58 L189.873169,82.4398414 C189.499889,83.7199205 188.326518,84.5999995 186.993123,84.5999995 L15.0068735,84.5999995 C13.673479,84.5999995 12.5001073,83.7199203 12.1268273,82.439841 L5,58 L5,58 Z"
          id="ca-path-16"
        ></path>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="ca-linearGradient-17"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M5,84 L11,84 L11,88 C11,89.6568542 9.65685425,91 8,91 C6.34314575,91 5,89.6568542 5,88 L5,84 L5,84 Z"
          id="ca-path-18"
        ></path>
        <path
          d="M17,84 L23,84 L23,88 C23,89.6568542 21.6568542,91 20,91 C18.3431458,91 17,89.6568542 17,88 L17,84 L17,84 Z"
          id="ca-path-19"
        ></path>
        <path
          d="M29,84 L35,84 L35,88 C35,89.6568542 33.6568542,91 32,91 C30.3431458,91 29,89.6568542 29,88 L29,84 L29,84 Z"
          id="ca-path-20"
        ></path>
        <path
          d="M41,84 L47,84 L47,88 C47,89.6568542 45.6568542,91 44,91 C42.3431458,91 41,89.6568542 41,88 L41,84 L41,84 Z"
          id="ca-path-21"
        ></path>
        <path
          d="M53,84 L59,84 L59,88 C59,89.6568542 57.6568542,91 56,91 C54.3431458,91 53,89.6568542 53,88 L53,84 L53,84 Z"
          id="ca-path-22"
        ></path>
        <path
          d="M65,84 L71,84 L71,88 C71,89.6568542 69.6568542,91 68,91 C66.3431458,91 65,89.6568542 65,88 L65,84 L65,84 Z"
          id="ca-path-23"
        ></path>
        <path
          d="M77,84 L83,84 L83,88 C83,89.6568542 81.6568542,91 80,91 C78.3431458,91 77,89.6568542 77,88 L77,84 L77,84 Z"
          id="ca-path-24"
        ></path>
        <path
          d="M89,84 L95,84 L95,88 C95,89.6568542 93.6568542,91 92,91 C90.3431458,91 89,89.6568542 89,88 L89,84 L89,84 Z"
          id="ca-path-25"
        ></path>
        <path
          d="M101,84 L107,84 L107,88 C107,89.6568542 105.656854,91 104,91 C102.343146,91 101,89.6568542 101,88 L101,84 L101,84 Z"
          id="ca-path-26"
        ></path>
        <path
          d="M113,84 L119,84 L119,88 C119,89.6568542 117.656854,91 116,91 C114.343146,91 113,89.6568542 113,88 L113,84 L113,84 Z"
          id="ca-path-27"
        ></path>
        <path
          d="M125,84 L131,84 L131,88 C131,89.6568542 129.656854,91 128,91 C126.343146,91 125,89.6568542 125,88 L125,84 L125,84 Z"
          id="ca-path-28"
        ></path>
        <path
          d="M137,84 L143,84 L143,88 C143,89.6568542 141.656854,91 140,91 C138.343146,91 137,89.6568542 137,88 L137,84 L137,84 Z"
          id="ca-path-29"
        ></path>
        <path
          d="M149,84 L155,84 L155,88 C155,89.6568542 153.656854,91 152,91 C150.343146,91 149,89.6568542 149,88 L149,84 L149,84 Z"
          id="ca-path-30"
        ></path>
        <path
          d="M161,84 L167,84 L167,88 C167,89.6568542 165.656854,91 164,91 C162.343146,91 161,89.6568542 161,88 L161,84 L161,84 Z"
          id="ca-path-31"
        ></path>
        <path
          d="M173,84 L179,84 L179,88 C179,89.6568542 177.656854,91 176,91 C174.343146,91 173,89.6568542 173,88 L173,84 L173,84 Z"
          id="ca-path-32"
        ></path>
        <path
          d="M185,84 L191,84 L191,88 C191,89.6568542 189.656854,91 188,91 C186.343146,91 185,89.6568542 185,88 L185,84 L185,84 Z"
          id="ca-path-33"
        ></path>
        <linearGradient
          x1="52.353444%"
          y1="-226.179428%"
          x2="50%"
          y2="110.096146%"
          id="ca-linearGradient-34"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M11,84 L17,84 L17,88 C17,89.6568542 15.6568542,91 14,91 C12.3431458,91 11,89.6568542 11,88 L11,84 L11,84 Z"
          id="ca-path-35"
        ></path>
        <path
          d="M23,84 L29,84 L29,88 C29,89.6568542 27.6568542,91 26,91 C24.3431458,91 23,89.6568542 23,88 L23,84 L23,84 Z"
          id="ca-path-36"
        ></path>
        <path
          d="M35,84 L41,84 L41,88 C41,89.6568542 39.6568542,91 38,91 C36.3431458,91 35,89.6568542 35,88 L35,84 L35,84 Z"
          id="ca-path-37"
        ></path>
        <path
          d="M47,84 L53,84 L53,88 C53,89.6568542 51.6568542,91 50,91 C48.3431458,91 47,89.6568542 47,88 L47,84 L47,84 Z"
          id="ca-path-38"
        ></path>
        <path
          d="M59,84 L65,84 L65,88 C65,89.6568542 63.6568542,91 62,91 C60.3431458,91 59,89.6568542 59,88 L59,84 L59,84 Z"
          id="ca-path-39"
        ></path>
        <path
          d="M71,84 L77,84 L77,88 C77,89.6568542 75.6568542,91 74,91 C72.3431458,91 71,89.6568542 71,88 L71,84 L71,84 Z"
          id="ca-path-40"
        ></path>
        <path
          d="M83,84 L89,84 L89,88 C89,89.6568542 87.6568542,91 86,91 C84.3431458,91 83,89.6568542 83,88 L83,84 L83,84 Z"
          id="ca-path-41"
        ></path>
        <path
          d="M95,84 L101,84 L101,88 C101,89.6568542 99.6568542,91 98,91 C96.3431458,91 95,89.6568542 95,88 L95,84 L95,84 Z"
          id="ca-path-42"
        ></path>
        <path
          d="M107,84 L113,84 L113,88 C113,89.6568542 111.656854,91 110,91 C108.343146,91 107,89.6568542 107,88 L107,84 L107,84 Z"
          id="ca-path-43"
        ></path>
        <path
          d="M119,84 L125,84 L125,88 C125,89.6568542 123.656854,91 122,91 C120.343146,91 119,89.6568542 119,88 L119,84 L119,84 Z"
          id="ca-path-44"
        ></path>
        <path
          d="M131,84 L137,84 L137,88 C137,89.6568542 135.656854,91 134,91 C132.343146,91 131,89.6568542 131,88 L131,84 L131,84 Z"
          id="ca-path-45"
        ></path>
        <path
          d="M143,84 L149,84 L149,88 C149,89.6568542 147.656854,91 146,91 C144.343146,91 143,89.6568542 143,88 L143,84 L143,84 Z"
          id="ca-path-46"
        ></path>
        <path
          d="M155,84 L161,84 L161,88 C161,89.6568542 159.656854,91 158,91 C156.343146,91 155,89.6568542 155,88 L155,84 L155,84 Z"
          id="ca-path-47"
        ></path>
        <path
          d="M167,84 L173,84 L173,88 C173,89.6568542 171.656854,91 170,91 C168.343146,91 167,89.6568542 167,88 L167,84 L167,84 Z"
          id="ca-path-48"
        ></path>
        <path
          d="M179,84 L185,84 L185,88 C185,89.6568542 183.656854,91 182,91 C180.343146,91 179,89.6568542 179,88 L179,84 L179,84 Z"
          id="ca-path-49"
        ></path>
        <path
          d="M191,84 L197,84 L197,88 C197,89.6568542 195.656854,91 194,91 C192.343146,91 191,89.6568542 191,88 L191,84 L191,84 Z"
          id="ca-path-50"
        ></path>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="ca-linearGradient-51"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M1,125.199998 L202,125.199998 C202.552285,125.199998 203,125.647713 203,126.199998 L203,128.399998 C203,128.952283 202.552285,129.399998 202,129.399998 L1,129.399998 C0.44771525,129.399998 6.76353751e-17,128.952283 0,128.399998 L0,126.199998 C-6.76353751e-17,125.647713 0.44771525,125.199998 1,125.199998 Z"
          id="ca-path-52"
        ></path>
      </defs>
      <g
        id="ca-Wireframe-v4-Layout-v2"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="ca-PWA-Desktop-Page2---Access-Categories---a"
          transform="translate(-870.000000, -572.000000)"
        >
          <g id="ca-cat-C" transform="translate(318.000000, 379.000000)">
            <g id="ca-Group-3" transform="translate(1.000000, 67.000000)">
              <g
                id="ca-category-A-supermarket"
                transform="translate(551.000000, 126.000000)"
              >
                <g id="ca-Rectangle">
                  <use fill="#8FD5EF" href="#ca-path-2"></use>
                  <use
                    fill="url(#ca-linearGradient-1)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-2"
                  ></use>
                </g>
                <g id="ca-Group-4" transform="translate(19.000000, 94.000000)">
                  <g id="ca-Rectangle-Copy-5">
                    <use fill="#487FB4" href="#ca-path-4"></use>
                    <use
                      fillOpacity="0.5"
                      fill="url(#ca-linearGradient-3)"
                      style={{ mixBlendMode: "multiply" }}
                      href="#ca-path-4"
                    ></use>
                  </g>
                  <g id="ca-Rectangle-Copy-47">
                    <use fill="#487FB4" href="#ca-path-6"></use>
                    <use
                      fillOpacity="0.5"
                      fill="url(#ca-linearGradient-5)"
                      style={{ mixBlendMode: "multiply" }}
                      href="#ca-path-6"
                    ></use>
                  </g>
                  <g id="ca-Rectangle-Copy-48">
                    <use fill="#487FB4" href="#ca-path-7"></use>
                    <use
                      fillOpacity="0.5"
                      fill="url(#ca-linearGradient-5)"
                      style={{ mixBlendMode: "multiply" }}
                      href="#ca-path-7"
                    ></use>
                  </g>
                  <g id="ca-Rectangle-Copy-46">
                    <use fill="#487FB4" href="#ca-path-8"></use>
                    <use
                      fillOpacity="0.5"
                      fill="url(#ca-linearGradient-3)"
                      style={{ mixBlendMode: "multiply" }}
                      href="#ca-path-8"
                    ></use>
                  </g>
                </g>
                <path
                  d="M69.7999989,34.5999995 L133.199998,34.5999995 C135.409137,34.5999995 137.199998,36.3908605 137.199998,38.5999995 L137.199998,62.5999995 C137.199998,64.8091385 135.409137,66.5999995 133.199998,66.5999995 L69.7999989,66.5999995 C67.5908599,66.5999995 65.7999989,64.8091385 65.7999989,62.5999995 L65.7999989,38.5999995 C65.7999989,36.3908605 67.5908599,34.5999995 69.7999989,34.5999995 Z"
                  id="ca-Rectangle-Copy-64"
                  stroke="#00AEEF"
                  strokeWidth="5.08474576"
                  strokeLinejoin="round"
                  transform="translate(101.499998, 50.600000) scale(1, -1) translate(-101.499998, -50.600000) "
                ></path>
                <g id="ca-Rectangle-Copy-7">
                  <use fill="#8FD5EF" href="#ca-path-10"></use>
                  <use
                    fill="url(#ca-linearGradient-9)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-10"
                  ></use>
                </g>
                <g id="ca-Combined-Shape">
                  <use fill="#487FB4" href="#ca-path-12"></use>
                  <use
                    fillOpacity="0.5"
                    fill="url(#ca-linearGradient-11)"
                    style={{ mixBlendMode: "multiply" }}
                    href="#ca-path-12"
                  ></use>
                </g>
                <g id="ca-Rectangle-Copy">
                  <use fill="#8FD5EF" href="#ca-path-14"></use>
                  <use
                    fill="url(#ca-linearGradient-13)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-14"
                  ></use>
                </g>
                <g
                  id="ca-Rectangle-Copy-44"
                  transform="translate(101.000000, 71.300000) scale(1, -1) translate(-101.000000, -71.300000) "
                >
                  <use fill="#00AEEF" href="#ca-path-16"></use>
                  <use
                    fill="url(#ca-linearGradient-15)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-16"
                  ></use>
                </g>
                <g id="ca-Rectangle">
                  <use fill="#00AEEF" href="#ca-path-18"></use>
                  <use
                    fill="url(#ca-linearGradient-17)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-18"
                  ></use>
                </g>
                <g id="ca-Rectangle-Copy-49">
                  <use fill="#00AEEF" href="#ca-path-19"></use>
                  <use
                    fill="url(#ca-linearGradient-17)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-19"
                  ></use>
                </g>
                <g id="ca-Rectangle-Copy-50">
                  <use fill="#00AEEF" href="#ca-path-20"></use>
                  <use
                    fill="url(#ca-linearGradient-17)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-20"
                  ></use>
                </g>
                <g id="ca-Rectangle-Copy-51">
                  <use fill="#00AEEF" href="#ca-path-21"></use>
                  <use
                    fill="url(#ca-linearGradient-17)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-21"
                  ></use>
                </g>
                <g id="ca-Rectangle-Copy-52">
                  <use fill="#00AEEF" href="#ca-path-22"></use>
                  <use
                    fill="url(#ca-linearGradient-17)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-22"
                  ></use>
                </g>
                <g id="ca-Rectangle-Copy-53">
                  <use fill="#00AEEF" href="#ca-path-23"></use>
                  <use
                    fill="url(#ca-linearGradient-17)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-23"
                  ></use>
                </g>
                <g id="ca-Rectangle-Copy-54">
                  <use fill="#00AEEF" href="#ca-path-24"></use>
                  <use
                    fill="url(#ca-linearGradient-17)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-24"
                  ></use>
                </g>
                <g id="ca-Rectangle-Copy-55">
                  <use fill="#00AEEF" href="#ca-path-25"></use>
                  <use
                    fill="url(#ca-linearGradient-17)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-25"
                  ></use>
                </g>
                <g id="ca-Rectangle-Copy-56">
                  <use fill="#00AEEF" href="#ca-path-26"></use>
                  <use
                    fill="url(#ca-linearGradient-17)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-26"
                  ></use>
                </g>
                <g id="ca-Rectangle-Copy-57">
                  <use fill="#00AEEF" href="#ca-path-27"></use>
                  <use
                    fill="url(#ca-linearGradient-17)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-27"
                  ></use>
                </g>
                <g id="ca-Rectangle-Copy-58">
                  <use fill="#00AEEF" href="#ca-path-28"></use>
                  <use
                    fill="url(#ca-linearGradient-17)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-28"
                  ></use>
                </g>
                <g id="ca-Rectangle-Copy-59">
                  <use fill="#00AEEF" href="#ca-path-29"></use>
                  <use
                    fill="url(#ca-linearGradient-17)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-29"
                  ></use>
                </g>
                <g id="ca-Rectangle-Copy-60">
                  <use fill="#00AEEF" href="#ca-path-30"></use>
                  <use
                    fill="url(#ca-linearGradient-17)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-30"
                  ></use>
                </g>
                <g id="ca-Rectangle-Copy-61">
                  <use fill="#00AEEF" href="#ca-path-31"></use>
                  <use
                    fill="url(#ca-linearGradient-17)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-31"
                  ></use>
                </g>
                <g id="ca-Rectangle-Copy-62">
                  <use fill="#00AEEF" href="#ca-path-32"></use>
                  <use
                    fill="url(#ca-linearGradient-17)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-32"
                  ></use>
                </g>
                <g id="ca-Rectangle-Copy-63">
                  <use fill="#00AEEF" href="#ca-path-33"></use>
                  <use
                    fill="url(#ca-linearGradient-17)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-33"
                  ></use>
                </g>
                <g id="ca-Rectangle-Copy-45">
                  <use fill="#8FD5EF" href="#ca-path-35"></use>
                  <use
                    fill="url(#ca-linearGradient-34)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-35"
                  ></use>
                </g>
                <g id="ca-Rectangle-Copy-65">
                  <use fill="#8FD5EF" href="#ca-path-36"></use>
                  <use
                    fill="url(#ca-linearGradient-34)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-36"
                  ></use>
                </g>
                <g id="ca-Rectangle-Copy-66">
                  <use fill="#8FD5EF" href="#ca-path-37"></use>
                  <use
                    fill="url(#ca-linearGradient-34)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-37"
                  ></use>
                </g>
                <g id="ca-Rectangle-Copy-67">
                  <use fill="#8FD5EF" href="#ca-path-38"></use>
                  <use
                    fill="url(#ca-linearGradient-34)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-38"
                  ></use>
                </g>
                <g id="ca-Rectangle-Copy-68">
                  <use fill="#8FD5EF" href="#ca-path-39"></use>
                  <use
                    fill="url(#ca-linearGradient-34)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-39"
                  ></use>
                </g>
                <g id="ca-Rectangle-Copy-69">
                  <use fill="#8FD5EF" href="#ca-path-40"></use>
                  <use
                    fill="url(#ca-linearGradient-34)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-40"
                  ></use>
                </g>
                <g id="ca-Rectangle-Copy-70">
                  <use fill="#8FD5EF" href="#ca-path-41"></use>
                  <use
                    fill="url(#ca-linearGradient-34)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-41"
                  ></use>
                </g>
                <g id="ca-Rectangle-Copy-71">
                  <use fill="#8FD5EF" href="#ca-path-42"></use>
                  <use
                    fill="url(#ca-linearGradient-34)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-42"
                  ></use>
                </g>
                <g id="ca-Rectangle-Copy-72">
                  <use fill="#8FD5EF" href="#ca-path-43"></use>
                  <use
                    fill="url(#ca-linearGradient-34)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-43"
                  ></use>
                </g>
                <g id="ca-Rectangle-Copy-73">
                  <use fill="#8FD5EF" href="#ca-path-44"></use>
                  <use
                    fill="url(#ca-linearGradient-34)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-44"
                  ></use>
                </g>
                <g id="ca-Rectangle-Copy-74">
                  <use fill="#8FD5EF" href="#ca-path-45"></use>
                  <use
                    fill="url(#ca-linearGradient-34)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-45"
                  ></use>
                </g>
                <g id="ca-Rectangle-Copy-75">
                  <use fill="#8FD5EF" href="#ca-path-46"></use>
                  <use
                    fill="url(#ca-linearGradient-34)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-46"
                  ></use>
                </g>
                <g id="ca-Rectangle-Copy-76">
                  <use fill="#8FD5EF" href="#ca-path-47"></use>
                  <use
                    fill="url(#ca-linearGradient-34)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-47"
                  ></use>
                </g>
                <g id="ca-Rectangle-Copy-77">
                  <use fill="#8FD5EF" href="#ca-path-48"></use>
                  <use
                    fill="url(#ca-linearGradient-34)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-48"
                  ></use>
                </g>
                <g id="ca-Rectangle-Copy-78">
                  <use fill="#8FD5EF" href="#ca-path-49"></use>
                  <use
                    fill="url(#ca-linearGradient-34)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-49"
                  ></use>
                </g>
                <g id="ca-Rectangle-Copy-79">
                  <use fill="#8FD5EF" href="#ca-path-50"></use>
                  <use
                    fill="url(#ca-linearGradient-34)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-50"
                  ></use>
                </g>
                <g
                  id="ca-Rectangle-Copy-37"
                  transform="translate(101.499998, 127.299998) scale(1, -1) translate(-101.499998, -127.299998) "
                >
                  <use fill="#00AEEF" href="#ca-path-52"></use>
                  <use
                    fill="url(#ca-linearGradient-51)"
                    style={{ mixBlendMode: "screen" }}
                    href="#ca-path-52"
                  ></use>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
